import { render, staticRenderFns } from "./FinalizationDialog.vue?vue&type=template&id=29b97830&scoped=true&"
import script from "./FinalizationDialog.vue?vue&type=script&lang=js&"
export * from "./FinalizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./FinalizationDialog.vue?vue&type=style&index=0&id=29b97830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b97830",
  null
  
)

export default component.exports